module.exports = "label {\n  margin-bottom: 0.8rem; }\n"